import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts&setup=true"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=12c7bfba&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c7bfba"]])

export default __exports__